import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class EventEmitterService {
  invokeHeaderComponentFunction = new EventEmitter();
  subsVar: Subscription;

  constructor() {}

  ComponentManipulator() {
    this.invokeHeaderComponentFunction.emit();
  }
}
